import React from 'react';

const IconLoader = () => (
  <>
    <style>{`
      @keyframes drawPolygon {
        to {
          stroke-dashoffset: 0;
        }
      }

      @keyframes fadeInLetter {
        to {
          opacity: 1;
          transform: scale(1) translateX(8px) translateY(1px);
        }
      }

      .logo-loader {
        width: 100px;
        height: 100px;
        display: block;
        margin: 0 auto;
        color: #64ffda;
      }

      .logo-polygon {
        stroke-dasharray: 300;
        stroke-dashoffset: 300;
        animation: drawPolygon 1.5s ease forwards;
      }

      .logo-letter {
        opacity: 0;
        transform: scale(0.85) translateX(10px);
        transform-origin: center;
        animation: fadeInLetter 0.6s ease forwards;
        animation-delay: 1.2s;
      }
    `}</style>

    <svg id="logo" className="logo-loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <title>Loader Logo</title>
      <g>
        <g id="A" className="logo-letter" transform="translate(21, 22)">
          <path
            d="M39.5,30.3 L44.5,30.3 L54.5,61 L49,61 
               L46.8,54.5 L37.2,54.5 L35,61 L29.5,61 
               L39.5,30.3 Z 
               M42,36.8 L39.2,49.5 L44.8,49.5 
               L42,36.8 Z"
            fill="currentColor"
          />
        </g>
        <path
          className="logo-polygon"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M 50, 5 
             L 11, 27 
             L 11, 72 
             L 50, 95 
             L 89, 73 
             L 89, 28 
             Z"
        />
      </g>
    </svg>
  </>
);

export default IconLoader;
